// extracted by mini-css-extract-plugin
export var container = "_dh-0";
export var icon = "_dh-1";
export var text = "_dh-2";